import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hub/helpers/use-store';
import {
  KycAnimationWrapperComponent,
  KycButton,
  KycContent,
} from './components';
import { useKycAnimation } from './hooks';
import { KycBannerContainer } from './styled';

export interface KycVerificationProps {
  showAnimation?: boolean;
  forceShow?: boolean;
}

const KycVerification: FC<KycVerificationProps> = ({
  showAnimation = true,
  forceShow = false,
}) => {
  const {
    dataStore: { userStore },
  } = useStore();

  // Only show if user requires verification or forced to show
  const shouldShow = userStore.verificationRequired || forceShow;

  // Handle animation timing and visibility
  const { isVisible, shouldRender } = useKycAnimation({
    shouldShow,
  });

  // Don't render at all if conditions aren't met
  if (!shouldShow || !shouldRender) {
    return null;
  }

  const content = (
    <KycBannerContainer>
      <KycContent />
      <KycButton />
    </KycBannerContainer>
  );

  if (showAnimation) {
    return (
      <KycAnimationWrapperComponent isVisible={isVisible}>
        {content}
      </KycAnimationWrapperComponent>
    );
  }

  return content;
};

export default observer(KycVerification);
